module.exports = __webpack_public_path__ + "media/new-message.6917d799.ogg";